import * as constant from "../constant.module.json";

let MainPath = `${constant.NewBaseUrl}Upload/`;
let TestPath = `${constant.TestBaseUrl}Upload/`;
export const paths = {
  ApplicantPhoto: `${MainPath}Member/Photo/`,
  Members: `${MainPath}Member/Photo/`,
  MemberPhoto: `${MainPath}Member/Photo/`,
  UserPhoto: `${MainPath}User/Photo/`,
  TasksAttachments: `${MainPath}Task/Attachment/`,
  TaskProcedureAttachments: `${MainPath}taskProcedure/attachment/`,
  ProjectsAttachments: `${MainPath}Project/attachment/`,
  ActivityAttachmnets: `${MainPath}Activity/attachment/`,
  ActivityProcedureAttachments: `${MainPath}ActivityProcedure/attachment/`,
  SubTaskAttachments: `${MainPath}SubTask/Attachment/`,
  SubTaskProcedureAttachments: `${MainPath}SubTaskProcedure/Attachment/`,
  CommunityCoverPhoto: `${MainPath}Community/CoverPhoto/`,
  CommunityLogo: `${MainPath}Community/Logo/`,
  MemberAttach: `${MainPath}Member/Attachment/`,
  Agenda: `${MainPath}Agenda/Attachment/`,
  PresidentialTask: `${MainPath}PresidentialTask/Attachment/`,
  PresidentialTaskComment: `${MainPath}PresidentialTaskComment/Attachment/`,
  SubPresidentialTask: `${MainPath}SubPresidentialTask/Attachment/`,
  SubPresidentialTaskComment: `${MainPath}SubPresidentialTaskComment/Attachment/`,
};
